import { Field } from 'formik'
import { FC } from 'react'
import { StyleFormWrapper, StyleLabel, StylePlaceholder } from '../style'
import { StyleMapInputWrapper } from './style'

interface MapProps {
  name: string
  label?: string
  placeholder?: string
  styleWrapper?: string
  styleLabel?: string
  styleInput?: string
  disabled?: boolean
}
const Map: FC<MapProps> = ({
  name,
  label,
  placeholder,
  disabled,
  styleWrapper,
  styleLabel,
  styleInput,
}) => {
  return (
    <Field name={name}>
      {({ field, meta, form }) => {
        const hasError = meta.touched && meta.error
        return (
          <StyleFormWrapper styleWrapper={styleWrapper}>
            {!!label && (
              <StyleLabel hasError={hasError} styleLabel={styleLabel}>
                {label}
              </StyleLabel>
            )}
            <StyleMapInputWrapper
              hasError={hasError}
              onClick={() => {}}
              disabled={disabled}
              styleInput={styleInput}
            >
              {!!placeholder && !field?.value ? (
                <StylePlaceholder>{placeholder}</StylePlaceholder>
              ) : (
                <></>
              )}
            </StyleMapInputWrapper>
          </StyleFormWrapper>
        )
      }}
    </Field>
  )
}

export default Map
